export enum MyDSpaceConfigurationValueType {
  Workspace = 'workspace',
  SupervisedItems = 'supervisedWorkspace',
  Workflow = 'workflow'
}
